import { render, staticRenderFns } from "./sectionDashboardIntroStyle2.vue?vue&type=template&id=487e99f2"
import script from "./sectionDashboardIntroStyle2.vue?vue&type=script&lang=js"
export * from "./sectionDashboardIntroStyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports